// v2/utils/miktarTaslak.js — urun listesinde (WarehouseCell) girilen depo+miktari
// hizli siparis kartina (QuickView) ve Detayli Siparis penceresine (ProductDetailModal) tasir.
// Anahtar: urun kodu -> { whKey, qty }. Yalnizca bellekte tutulur; sayfa yenilenince sifirlanir.
import { useSyncExternalStore } from 'react';

const taslaklar = new Map();
const dinleyiciler = new Set();

function yayinla() {
  dinleyiciler.forEach((fn) => {
    try { fn(); } catch (e) { /* dinleyici hatasi digerlerini engellemesin */ }
  });
}

function abone(fn) {
  dinleyiciler.add(fn);
  return () => dinleyiciler.delete(fn);
}

/** Musteri satirda miktari degistirince cagrilir. Ayni deger tekrar yazilmaz. */
export function taslakYaz(kod, whKey, qty) {
  if (!kod || !whKey) return;
  const n = Math.max(parseInt(qty, 10) || 1, 1);
  const eski = taslaklar.get(kod);
  if (eski && eski.whKey === whKey && eski.qty === n) return;
  taslaklar.set(kod, { whKey, qty: n });   // yeni nesne -> useSyncExternalStore degisikligi gorur
  yayinla();
}

/** { whKey, qty } | null — degismedikce ayni nesneyi doner (kararli referans). */
export function taslakOku(kod) {
  return (kod && taslaklar.get(kod)) || null;
}

/** Bilesen icin: urunun taslagi degisince yeniden cizer. */
export function useMiktarTaslak(kod) {
  return useSyncExternalStore(abone, () => taslakOku(kod), () => null);
}
